export const getLoginLink = (
  currentLocation: string,
  appConfig: typeof CSS_CONFIG,
): string => {
  const { COUNTRY, LANGUAGE, LOGINLINK } = appConfig;
  const setLocale = (): string => `${COUNTRY}/${LANGUAGE}`;

  return `${LOGINLINK.replace('LOCALE', setLocale)}?from=${currentLocation}`;
};
